import { toast } from '@qodo/design-system';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { PlatformClient } from '../httpClients/PlatformClient';
import { QUERY_KEYS } from '../queries/consts';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

/**
 * Hook to delete an organization invite by its document ID
 * @returns Mutation object for deleting an invite
 */
export const useDeleteInviteMutation = () => {
  const queryClient = useQueryClient();
  const spawnActions = spawn('toasts.organization.delete-invite');

  return useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_INVITE],
    mutationFn: async (inviteId: string) => {
      return await PlatformClient.deleteInvite(inviteId);
    },
    onSuccess: () => {
      toast.success(spawnActions('success'));
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.ORGANIZATION_MEMBERS],
      });
    },
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnActions('error'));

      toast.error(errorFromServer);
    },
  });
};
